'use client'

import { useState, useRef, useEffect } from "react";

function useSwiperRef<T extends HTMLElement>(): [T | null, React.RefObject<T | null>] {
  const [wrapper, setWrapper] = useState<T | null>(null);
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      setWrapper(ref.current);
    }
  }, []);

  return [wrapper, ref];
}

export default useSwiperRef;
